import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledView = styled(FlexColumn)`
    flex: 1;
    min-width: 0;
    overflow-y: auto;
`;
